'use client';
import { getQueryClient } from '@/lib/queryClient';
import { QueryClientProvider } from '@tanstack/react-query';
import type * as React from 'react';
import { TooltipProvider } from '../ui/tooltip';
import { PostHogProvider } from './PostHogProvider';
import { AuthProvider } from './AuthProvider';
import type { SupportedLanguages } from '@/i18n/routing';

export default function Providers({
	locale: _locale,
	children,
}: {
	locale?: SupportedLanguages;
	children: React.ReactNode;
}) {
	const queryClient = getQueryClient();

	return (
		<AuthProvider>
			<QueryClientProvider client={queryClient}>
				<PostHogProvider>
					<TooltipProvider>{children}</TooltipProvider>
				</PostHogProvider>
			</QueryClientProvider>
		</AuthProvider>
	);
}
